import React from 'react';
import { StyledSystemProps } from '@creditas-ui/react';
import { FloatingContainer, OptionList } from './ProfileOptionList.style';

interface ProfileOptionListBaseProps {
  children: React.ReactNode;
}

type ProfileOptionListElProps = React.HTMLAttributes<HTMLDivElement>;

type ProfileOptionListProps = ProfileOptionListBaseProps &
  ProfileOptionListElProps &
  StyledSystemProps;

const ProfileOptionList = ({ children, ...props }: ProfileOptionListProps): JSX.Element => (
  <FloatingContainer>
    <OptionList {...props}>{children}</OptionList>
  </FloatingContainer>
);

export { ProfileOptionList };
